import React from "react";
import moment from "moment";
import { Link } from "react-router";
import { Table, Tr, Td, Sort } from "reactable";
import {
  Dialog,
  TextField,
  Checkbox,
  RaisedButton,
  FlatButton
} from "material-ui";

import connectToStores from "alt-utils/lib/connectToStores";
import CreditStore from "../../stores/CreditStore";
import CreditActions from "../../actions/CreditActions";

import QuantityEditor from "./quantity-editor.jsx";
import Label from "./label.jsx";
import LinkLike from "./link-like.jsx";

const PAGE_SIZE = 5;

class CreditsWidget extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentPage: 0,
      newChangeOpen: false,
      newChangeQuantity: 0,
      newChangeDescription: "Credit adjustment"
    };

    this.showNewChange = this.showNewChange.bind(this);
    this.save = this.save.bind(this);
    this.hideNewChange = this.hideNewChange.bind(this);
  }

  static getStores() {
    return [CreditStore];
  }

  static getPropsFromStores() {
    return {
      getCreditRecordByPerson: CreditStore.getCreditRecordByPerson
    };
  }

  componentWillMount() {
    this.componentWillReceiveProps(this.props);
  }

  componentWillReceiveProps(props) {
    const key = `${props.person}${props.eventBucket}`;
    if (!this.state.fetched || this.state.fetched !== key) {
      this.setState({ fetched: key }, () => {
        CreditActions.fetchCreditRecordForPerson.defer({
          person: props.person,
          event_bucket: props.eventBucket
        });
      });
    }
  }

  showNewChange() {
    this.setState({ newChangeOpen: true });
  }

  save() {
    CreditActions.addCreditRecordEvent({
      person: this.props.person,
      event_bucket: this.props.eventBucket,
      credits_change: this.state.newChangeQuantity,
      description: this.state.newChangeDescription
    });
    this.hideNewChange();
  }

  hideNewChange() {
    this.setState({ newChangeOpen: false });
  }

  _makeRowForEvent(event) {
    return (
      <Tr key={event.created_at}>
        <Td column="Date">{moment(event.created_at).format("lll")}</Td>
        <Td column="Change">{`${event.credits_change > 0 ? "+" : ""}${
          event.credits_change
        }`}</Td>
        <Td column="Description">{event.description}</Td>
      </Tr>
    );
  }

  render() {
    const record = this.props.getCreditRecordByPerson({
      person: this.props.person,
      event_bucket: this.props.eventBucket
    });

    return (
      <div>
        <Dialog
          title={"Credit adjustment"}
          openImmediately={true}
          contentStyle={{ maxWidth: 400 }}
          actions={[
            <FlatButton label="Cancel" onTouchTap={this.hideNewChange} />,
            <FlatButton primary={true} label="Save" onTouchTap={this.save} />
          ]}
          modal={true}
          open={this.state.newChangeOpen}
          onRequestClose={this.hideNewChange}
        >
          <div>
            <Label>Credit change (+/-)</Label>
            <QuantityEditor
              style={{ marginTop: -14, marginLeft: -17 }}
              quantity={this.state.newChangeQuantity}
              updateQuantity={q => this.setState({ newChangeQuantity: q })}
            />
          </div>
          <div>
            <TextField
              value={this.state.newChangeDescription}
              floatingLabelText="Description (customer-visible)"
              floatingLabelFixed={true}
              onChange={e =>
                this.setState({ newChangeDescription: e.target.value })
              }
            />
          </div>
          <div
            style={{ marginTop: "1em", marginBottom: "-0.75em", fontSize: 12 }}
          >
            When you click save, the customer will receive an email.
          </div>
        </Dialog>
        {this.props.showHeader ? (
          <h2 style={Object.assign({ height: 25 }, this.props.headerStyle)}>
            Credits ({record ? record.credits : 0} available)
          </h2>
        ) : null}
        <div style={{ float: "right", marginTop: -46 }}>
          <RaisedButton
            onClick={() => this.showNewChange()}
            label="Manually adjust credits"
          />
        </div>
        <div>
          <Table
            className="bordered striped responsive-table"
            columns={["Date", "Change", "Description"]}
            itemsPerPage={
              record && record.events.length > PAGE_SIZE ? PAGE_SIZE : undefined
            }
            currentPage={this.state.currentPage}
            onPageChange={p => this.setState({ currentPage: p })}
          >
            {record
              ? record.events
                  .sort(
                    (a, b) =>
                      b.created_at.localeCompare(a.created_at) ||
                      b.description.localeCompare(a.description)
                  )
                  .map(this._makeRowForEvent)
              : []}
          </Table>
        </div>
        {!record || record.events.length === 0 ? (
          <div className="empty-table-message">
            No credits issued yet.{" "}
            <LinkLike onTouchTap={() => this.showNewChange()}>
              Manually issue credits.
            </LinkLike>
          </div>
        ) : null}
      </div>
    );
  }
}

export default connectToStores(CreditsWidget);



// WEBPACK FOOTER //
// ./src/app/components/partials/credits-widget.jsx